import React, { useContext, useState } from 'react';
import formatCurrency from 'shared/utils/formatCurrency';
import { Payment } from 'shared/graphql/query/app';
import { formatDate } from 'shared/utils/dateTime';
import { Text } from 'shared/components';
import { ApprovePaymentContext } from 'views/AccountPayment/common/context/ApprovePaymentContext';
import SelectBankAccountsField from 'views/AccountPayment/common/components/SelectBankAccountsField';
import { StyledTable } from './Styles';

type ExpandedRowProps = {
  data: Payment[];
  appStatus?: number;
  onChangeBankAccount?: (
    paymentId: string,
    bank_account?: {
      bank_name: string;
      bank_branch: string;
      account_name: string;
      account_number: string;
    },
  ) => void;
};

const columns = [
  {
    title: 'วันที่เอกสาร',
    dataIndex: 'column1',
    width: 110,
  },
  {
    title: 'รหัสใบสั่งจ่าย',
    dataIndex: 'column2',
    width: 110,
  },
  {
    title: 'รหัส Shipment/JOB/Booking',
    dataIndex: 'column3',
    width: 220,
  },
  {
    title: 'จำนวนตั้งเบิก (บาท)',
    dataIndex: 'column4',
    align: 'right',
    width: 150,
  },
  {
    title: 'หมายเหตุ',
    dataIndex: 'column5',
    width: 200,
  },
  {
    title: 'บัญชีที่ต้องการโอนออก',
    dataIndex: 'column6',
  },
];

const ExpandedRow: React.FC<ExpandedRowProps> = (props) => {
  const { data, appStatus, onChangeBankAccount } = props;
  const { selectedApprovePaymentDetail } = useContext(ApprovePaymentContext);
  const { paymentBankAccounts } = selectedApprovePaymentDetail;
  const [selectedBankAccount, setSelectedBankAccount] = useState<{
    _id: string;
    bank_name: string;
    bank_branch: string;
    account_name: string;
    account_number: string;
  } | null>(null);
  const paymentsDataTable = data.map((item, index) => {
    let oldBankAccount = item.bank_account || null;
    if (paymentBankAccounts) {
      const matchedBankAccount = paymentBankAccounts.find((bankAcc) => bankAcc._id === item._id);
      if (matchedBankAccount && matchedBankAccount.bank_account) {
        oldBankAccount = matchedBankAccount.bank_account;
      }
    }

    return {
      key: index,
      column1: item.create_date ? formatDate(item.create_date) : '-',
      column2: item.payment_number || '-',
      column3: item.number_ref || '-',
      column4: (
        <Text customType="primary" strong>
          {formatCurrency(item.grand_total_price, '-')}
        </Text>
      ),
      column5: item.payment_remark || '-',
      column6: (
        <Text customType="primary" strong>
          <SelectBankAccountsField
            disabled={appStatus ? appStatus >= 2 : false}
            value={(() => {
              if (selectedBankAccount && selectedBankAccount._id === item._id) {
                return `${selectedBankAccount.account_number} (${selectedBankAccount.bank_name})`;
              }
              if (oldBankAccount) {
                return `${oldBankAccount.account_number} (${oldBankAccount.bank_name})`;
              }
              return '';
            })()}
            onChange={(value) => {
              // eslint-disable-next-line no-shadow
              const Selectedbank = {
                _id: item._id,
                bank_name: value.bankName,
                bank_branch: value.bankBranch,
                account_name: value.accountName,
                account_number: value.accountNumber,
              };
              setSelectedBankAccount(Selectedbank);
              const bankAccount = {
                bank_name: value.bankName,
                bank_branch: value.bankBranch,
                account_name: value.accountName,
                account_number: value.accountNumber,
              };
              onChangeBankAccount?.(item._id, bankAccount);
            }}
          />
        </Text>
      ),
    };
  });

  return (
    <div style={{ marginTop: 10 }}>
      <StyledTable
        scroll={{ x: 'max-content' }}
        pagination={false}
        columns={columns}
        dataSource={paymentsDataTable}
        size="small"
      />
    </div>
  );
};

export default ExpandedRow;
